import * as ismobilejs from 'ismobilejs'

export const isMobile = ismobilejs.default(window.navigator)
